import { createContext } from 'react'

type InfoListLayoutContextType = {
  labelWidth?: string
}

const InfoListLayoutContext = createContext<InfoListLayoutContextType>({})

export default InfoListLayoutContext
